import { NotificationManager, PaymentV2Api } from '@atlas/core';

export const submitWithdrawal = async ({ amount, currency, paymentMethod, requestData }) => {
  const response = await PaymentV2Api.createAsyncWithdrawalV2(requestData);

  NotificationManager.display({
    data: {
      amount,
      currency,
      publicPaymentId: response?.publicPaymentId,
      paymentMethod,
    },
    message: 'successfulWithdrawal',
    type: 'successfulWithdrawal',
  });

  return response;
};

export const showWithdrawalError = () => {
  NotificationManager.display({
    data: {
      errorType: true,
      headerTitle: 'withdrawal',
      title: 'failed_sad_emoticon',
    },
    type: 'withdrawalResultPopup',
  });
};

export const showWithdrawalErrorWithSupport = () => {
  NotificationManager.display({
    data: {
      errorType: true,
      headerTitle: 'withdrawal',
      text: 'something_went_wrong_contact_support',
      title: 'failed_sad_emoticon',
    },
    type: 'withdrawalResultPopup',
  });
};
